<template>
  <div class="menu-item-wrapper">
    <i v-if="icon" :class="icon" class="menu-icon" />
    <span class="menu-title">{{ title }}</span>
    <el-badge v-if="isCustomerService && unread > 0" :value="unread" :max="99" class="cs-badge" />
  </div>
</template>

<script>
import { getUnreadTotal } from '@/api/customerService'

// 组件会被每个菜单项实例化，未读轮询只挂在「客服消息」这一项上
export default {
  name: 'MenuItem',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      unread: 0,
      timer: null
    }
  },
  computed: {
    isCustomerService() {
      return this.title === '客服消息'
    },
    regionKey() {
      return (this.$store.getters.regionSelected || []).join('|')
    },
    regionParams() {
      return this.$store.getters.regionParams || {}
    }
  },
  watch: {
    regionKey() {
      if (!this.isCustomerService) return
      this.unread = 0
      this.fetchUnread()
    }
  },
  mounted() {
    if (this.isCustomerService) {
      this.fetchUnread()
      this.timer = setInterval(this.fetchUnread, 20000)
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    fetchUnread() {
      const requestRegionKey = this.regionKey
      getUnreadTotal(this.regionParams).then(res => {
        if (requestRegionKey !== this.regionKey) return
        this.unread = (res.data && res.data.count) || 0
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-item-wrapper {
  display: flex;
  align-items: center;

  .menu-icon {
    font-size: 16px;
    margin-right: 12px;
    width: 20px;
    text-align: center;
    transition: all 0.3s ease;
  }

  .menu-title {
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .cs-badge {
    margin-left: 8px;
    line-height: 1;
  }
}
</style>
